import type { DripsyColor } from "@utils";
import { useDripsyColor } from "@utils";
import * as React from "react";
import Svg, { G, Path } from "react-native-svg";

function OptionsIcon({ size, color }: { size: number; color: DripsyColor }) {
  const finalColor = useDripsyColor({ color });
  return (
    <Svg width={size} height={size} viewBox="0 0 16 16">
      <G id="CC" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <G id="button-/-filter" transform="translate(-117.000000, -7.000000)" fill={finalColor} fillRule="nonzero">
          <G id="option" transform="translate(117.000000, 7.000000)">
            <Path
              d="M5,2 C4.448,2 4,2.448 4,3 C4,3.552 4.448,4 5,4 C5.552,4 6,3.552 6,3 C6,2.448 5.552,2 5,2 Z M1,2 L2.171,2 C2.583,0.835 3.694,0 5,0 C6.306,0 7.417,0.835 7.829,2 L15,2 C15.552,2 16,2.448 16,3 C16,3.552 15.552,4 15,4 L7.829,4 C7.417,5.165 6.306,6 5,6 C3.694,6 2.583,5.165 2.171,4 L1,4 C0.448,4 1.33226763e-15,3.552 1.33226763e-15,3 C1.33226763e-15,2.448 0.448,2 1,2 Z M15,12 C15.552,12 16,12.448 16,13 C16,13.552 15.552,14 15,14 L13.829,14 C13.417,15.165 12.306,16 11,16 C9.694,16 8.583,15.165 8.171,14 L1,14 C0.448,14 1.33226763e-15,13.552 1.33226763e-15,13 C1.33226763e-15,12.448 0.448,12 1,12 L8.171,12 C8.583,10.835 9.694,10 11,10 C12.306,10 13.417,10.835 13.829,12 L15,12 Z M10,13 C10,13.552 10.448,14 11,14 C11.552,14 12,13.552 12,13 C12,12.448 11.552,12 11,12 C10.448,12 10,12.448 10,13 Z"
              id="Shape"
            />
          </G>
        </G>
      </G>
    </Svg>
  );
}
export default OptionsIcon;
